// extracted by mini-css-extract-plugin
module.exports = {"main":"main_dyJWz","icon":"icon_HSpAz","other":"other_GdNiO","register":"register_68Kic","prefixIcon":"prefixIcon_e0jCy"};